// Simple i18n dictionary for 5 languages.
export const LANGUAGES = [
    { code: "en", label: "English", short: "EN" },
    { code: "de", label: "Deutsch", short: "DE" },
    { code: "fr", label: "Français", short: "FR" },
    { code: "es", label: "Español", short: "ES" },
    { code: "it", label: "Italiano", short: "IT" },
];

export const TRANSLATIONS = {
    en: {
        "nav.home": "Home",
        "nav.masalas": "Spices",
        "nav.decor": "Home Decor",
        "nav.jewelry": "Jewelry",
        "nav.shop": "Shop",
        "nav.account": "Account",
        "nav.login": "Sign In",
        "nav.logout": "Sign Out",
        "nav.register": "Register",
        "nav.cart": "Cart",
        "nav.admin": "Admin",
        "hero.eyebrow": "Est. Noida, India · Three houses under one roof",
        "hero.title": "Small-batch spices. Handcrafted textiles. Artisan jewelry.",
        "hero.subtitle": "From stone-ground masalas to zardosi wall art and hand-set kundan — every piece begins on a wooden frame, an open flame, or a jeweller's bench. Never a factory line.",
        "hero.cta": "Enter the atelier",
        "hero.cta2": "The story of Keneth",
        "sec.verticals.title": "Three houses. One workshop.",
        "sec.verticals.sub": "Choose your entry — the kitchen, the drawing room, or the vanity. Each is worked by a different family of makers, all under one roof in Noida.",
        "vert.masalas.title": "The Spice House",
        "vert.masalas.desc": "Hand-roasted, stone-ground, sealed within hours. Six signature blends and single-origin single spices.",
        "vert.decor.title": "The Fabric House",
        "vert.decor.desc": "Zardosi wall panels, silk-velvet cushions, sculptural brass napkin rings and festive velvet — for the drawing room and the celebration.",
        "vert.jewelry.title": "The Jewel House",
        "vert.jewelry.desc": "Kundan, meenakari, temple gold and polki — heirloom-quality artisan jewelry, plus vegetable-tanned leather trifolds.",
        "sec.featured.title": "Featured this season",
        "sec.featured.sub": "A curated shortlist across all three houses.",
        "sec.craft.title": "The unhurried way",
        "sec.craft.p1": "Nothing in our workshops is measured in minutes. A single zardosi wall panel takes our master embroiderer six months. A batch of Nawabi biryani masala roasts for seven hours. A kundan choker is set stone-by-stone over three weeks.",
        "sec.craft.p2": "The result is a small catalogue — small enough for us to know every maker by name, generous enough for you to build a home worth passing on.",
        "sec.press.title": "As encountered in",
        "sec.newsletter.title": "The dispatch.",
        "sec.newsletter.sub": "Seasonal notes, new arrivals, and the occasional field-note from the atelier. Never more than twice a month.",
        "sec.newsletter.placeholder": "Your email",
        "sec.newsletter.submit": "Subscribe",
        "shop.title": "The shop",
        "shop.filter.all": "All",
        "shop.filter.masalas": "Spices",
        "shop.filter.decor": "Home Decor",
        "shop.filter.jewelry": "Jewelry",
        "shop.empty": "No products match your filter.",
        "prod.addCart": "Add to cart",
        "prod.buyNow": "Buy now",
        "prod.details": "Details",
        "prod.qty": "Quantity",
        "prod.related": "You may also like",
        "cart.title": "Your cart",
        "cart.empty": "Your cart is quiet. Start browsing to fill it.",
        "cart.item": "Item",
        "cart.qty": "Qty",
        "cart.price": "Price",
        "cart.total": "Total",
        "cart.subtotal": "Subtotal",
        "cart.checkout": "Proceed to checkout",
        "cart.continue": "Continue shopping",
        "cart.remove": "Remove",
        "checkout.processing": "Preparing your checkout…",
        "success.title": "Thank you.",
        "success.sub": "Your order has been received. A confirmation will arrive by email.",
        "success.orderId": "Order reference",
        "success.viewOrders": "View my orders",
        "cancel.title": "Payment cancelled",
        "cancel.sub": "No charge was made. You can return to your cart at any time.",
        "cancel.back": "Back to cart",
        "auth.login.title": "Welcome back",
        "auth.login.sub": "Sign in to view orders and check out faster.",
        "auth.register.title": "Create an account",
        "auth.register.sub": "For a more personal correspondence.",
        "auth.email": "Email",
        "auth.password": "Password",
        "auth.name": "Full name",
        "auth.signIn": "Sign in",
        "auth.signUp": "Create account",
        "auth.noAccount": "Don't have an account?",
        "auth.hasAccount": "Already have an account?",
        "acct.title": "Your orders",
        "acct.sub": "A record of every dispatch from Keneth Global.",
        "acct.empty": "No orders yet.",
        "acct.orderId": "Order",
        "acct.date": "Placed on",
        "acct.status": "Status",
        "acct.amount": "Amount",
        "acct.items": "Items",
        "admin.title": "Atelier — admin",
        "admin.stats": "At a glance",
        "admin.products": "Products",
        "admin.orders": "Orders",
        "admin.users": "Customers",
        "admin.revenue": "Revenue",
        "footer.about": "House",
        "footer.about.about": "About Us",
        "footer.about.craft": "Craftsmanship",
        "footer.about.press": "Press",
        "footer.shop": "Shop",
        "footer.support": "Client care",
        "footer.support.contact": "Contact",
        "footer.support.shipping": "Shipping",
        "footer.support.returns": "Returns",
        "footer.legal": "© 2026 Keneth Global Inc. All rights reserved.",
        "footer.tagline": "Shop the world anytime, anywhere.",
        "common.loading": "Loading…",
        "badge.new": "New",
    },
    de: {
        "nav.home": "Startseite",
        "nav.masalas": "Indische Gewürze",
        "nav.decor": "Wohndekor",
        "nav.jewelry": "Schmuck",
        "nav.shop": "Shop",
        "nav.account": "Konto",
        "nav.login": "Anmelden",
        "nav.logout": "Abmelden",
        "nav.register": "Registrieren",
        "nav.cart": "Warenkorb",
        "nav.admin": "Admin",
        "hero.eyebrow": "Gegr. Indien · Export nach Europa",
        "hero.title": "Die stillsten Luxusgüter der Welt.",
        "hero.subtitle": "Handgeröstete indische Gewürze, handgefertigte Textilien und Kunsthandwerk-Schmuck — direkt aus Delhi.",
        "hero.cta": "Kollektion entdecken",
        "hero.cta2": "Unsere Geschichte",
        "sec.verticals.title": "Drei Häuser. Ein Ursprung.",
        "sec.verticals.sub": "Jedes Stück beginnt in einer kleinen Werkstatt oder Familienküche — niemals in einer Fabrik.",
        "vert.masalas.title": "Das Gewürzhaus",
        "vert.masalas.desc": "Handgeröstet, steingemahlen, innerhalb weniger Stunden versiegelt.",
        "vert.decor.title": "Das Stoffhaus",
        "vert.decor.desc": "Blockgedruckte und handbestickte Textilien aus sechs indischen Staaten.",
        "vert.jewelry.title": "Das Schmuckhaus",
        "vert.jewelry.desc": "Handgefertigter Kunsthandwerk-Schmuck — Kundan, Meenakari, Tempelgold.",
        "sec.featured.title": "Diese Saison im Blickpunkt",
        "sec.featured.sub": "Eine kuratierte Auswahl aus allen drei Häusern.",
        "sec.craft.title": "Der unaufgeregte Weg",
        "sec.craft.p1": "Nichts in unseren Werkstätten wird in Minuten gemessen. Unser Garam Masala wird nur fünfundvierzig Tage im Jahr geröstet.",
        "sec.craft.p2": "Das Ergebnis ist ein Katalog von einundneunzig Produkten in drei Bereichen.",
        "sec.press.title": "Erwähnt in",
        "sec.newsletter.title": "Die Depesche.",
        "sec.newsletter.sub": "Saisonale Notizen und Neuheiten. Nie öfter als zweimal im Monat.",
        "sec.newsletter.placeholder": "Ihre E-Mail",
        "sec.newsletter.submit": "Abonnieren",
        "shop.title": "Der Shop",
        "shop.filter.all": "Alle",
        "shop.filter.masalas": "Indische Gewürze",
        "shop.filter.decor": "Wohndekor",
        "shop.filter.jewelry": "Schmuck",
        "shop.empty": "Keine Produkte gefunden.",
        "prod.addCart": "In den Warenkorb",
        "prod.buyNow": "Jetzt kaufen",
        "prod.details": "Details",
        "prod.qty": "Menge",
        "prod.related": "Vielleicht auch interessant",
        "cart.title": "Ihr Warenkorb",
        "cart.empty": "Ihr Warenkorb ist leer.",
        "cart.item": "Artikel",
        "cart.qty": "Anz.",
        "cart.price": "Preis",
        "cart.total": "Gesamt",
        "cart.subtotal": "Zwischensumme",
        "cart.checkout": "Zur Kasse",
        "cart.continue": "Weiter einkaufen",
        "cart.remove": "Entfernen",
        "checkout.processing": "Ihre Bestellung wird vorbereitet…",
        "success.title": "Vielen Dank.",
        "success.sub": "Ihre Bestellung wurde entgegengenommen.",
        "success.orderId": "Bestellreferenz",
        "success.viewOrders": "Meine Bestellungen",
        "cancel.title": "Zahlung abgebrochen",
        "cancel.sub": "Es wurde keine Belastung vorgenommen.",
        "cancel.back": "Zurück zum Warenkorb",
        "auth.login.title": "Willkommen zurück",
        "auth.login.sub": "Melden Sie sich an.",
        "auth.register.title": "Konto erstellen",
        "auth.register.sub": "Für eine persönlichere Korrespondenz.",
        "auth.email": "E-Mail",
        "auth.password": "Passwort",
        "auth.name": "Vollständiger Name",
        "auth.signIn": "Anmelden",
        "auth.signUp": "Konto erstellen",
        "auth.noAccount": "Noch kein Konto?",
        "auth.hasAccount": "Bereits ein Konto?",
        "acct.title": "Ihre Bestellungen",
        "acct.sub": "Eine Aufzeichnung jeder Sendung.",
        "acct.empty": "Noch keine Bestellungen.",
        "acct.orderId": "Bestellung",
        "acct.date": "Bestellt am",
        "acct.status": "Status",
        "acct.amount": "Betrag",
        "acct.items": "Artikel",
        "admin.title": "Atelier — Admin",
        "admin.stats": "Auf einen Blick",
        "admin.products": "Produkte",
        "admin.orders": "Bestellungen",
        "admin.users": "Kunden",
        "admin.revenue": "Umsatz",
        "footer.about": "Haus",
        "footer.about.about": "Über uns",
        "footer.about.craft": "Handwerkskunst",
        "footer.about.press": "Presse",
        "footer.shop": "Shop",
        "footer.support": "Kundenservice",
        "footer.support.contact": "Kontakt",
        "footer.support.shipping": "Versand",
        "footer.support.returns": "Rücksendungen",
        "footer.legal": "© 2026 Keneth Global Inc. Alle Rechte vorbehalten.",
        "footer.tagline": "Shoppen Sie die Welt, jederzeit, überall.",
        "common.loading": "Lädt…",
        "badge.new": "Neu",
    },
    fr: {
        "nav.home": "Accueil",
        "nav.masalas": "Épices Indiennes",
        "nav.decor": "Décor",
        "nav.jewelry": "Bijoux",
        "nav.shop": "Boutique",
        "nav.account": "Compte",
        "nav.login": "Se connecter",
        "nav.logout": "Déconnexion",
        "nav.register": "S'inscrire",
        "nav.cart": "Panier",
        "nav.admin": "Admin",
        "hero.eyebrow": "Fondé en Inde · Export vers l'Europe",
        "hero.title": "Les luxes les plus discrets du monde.",
        "hero.subtitle": "Épices indiennes en petits lots, textiles d'intérieur artisanaux et bijoux d'artisan — expédiés de Delhi à votre table.",
        "hero.cta": "Explorer la collection",
        "hero.cta2": "Notre histoire",
        "sec.verticals.title": "Trois maisons. Une origine.",
        "sec.verticals.sub": "Chaque pièce naît dans un petit atelier ou une cuisine familiale — jamais dans une usine.",
        "vert.masalas.title": "La Maison des Épices",
        "vert.masalas.desc": "Torréfiées à la main, broyées à la pierre, scellées en quelques heures.",
        "vert.decor.title": "La Maison des Tissus",
        "vert.decor.desc": "Textiles imprimés au bloc et brodés à la main, issus de six États indiens.",
        "vert.jewelry.title": "La Maison des Bijoux",
        "vert.jewelry.desc": "Bijoux d'artisan faits main — kundan, meenakari, or de temple.",
        "sec.featured.title": "En vedette cette saison",
        "sec.featured.sub": "Une sélection des trois maisons.",
        "sec.craft.title": "La voie lente",
        "sec.craft.p1": "Rien dans nos ateliers ne se mesure en minutes.",
        "sec.craft.p2": "Le résultat : un catalogue de quatre-vingt-onze produits en trois univers.",
        "sec.press.title": "Repéré dans",
        "sec.newsletter.title": "La dépêche.",
        "sec.newsletter.sub": "Notes saisonnières et nouveautés. Deux fois par mois maximum.",
        "sec.newsletter.placeholder": "Votre email",
        "sec.newsletter.submit": "S'abonner",
        "shop.title": "La boutique",
        "shop.filter.all": "Tout",
        "shop.filter.masalas": "Épices Indiennes",
        "shop.filter.decor": "Décor",
        "shop.filter.jewelry": "Bijoux",
        "shop.empty": "Aucun produit ne correspond à votre filtre.",
        "prod.addCart": "Ajouter au panier",
        "prod.buyNow": "Acheter",
        "prod.details": "Détails",
        "prod.qty": "Quantité",
        "prod.related": "Vous pourriez aimer",
        "cart.title": "Votre panier",
        "cart.empty": "Votre panier est vide.",
        "cart.item": "Article",
        "cart.qty": "Qté",
        "cart.price": "Prix",
        "cart.total": "Total",
        "cart.subtotal": "Sous-total",
        "cart.checkout": "Passer à la caisse",
        "cart.continue": "Continuer les achats",
        "cart.remove": "Retirer",
        "checkout.processing": "Préparation…",
        "success.title": "Merci.",
        "success.sub": "Votre commande a été reçue.",
        "success.orderId": "Référence",
        "success.viewOrders": "Voir mes commandes",
        "cancel.title": "Paiement annulé",
        "cancel.sub": "Aucun débit n'a été effectué.",
        "cancel.back": "Retour au panier",
        "auth.login.title": "Ravi de vous revoir",
        "auth.login.sub": "Connectez-vous.",
        "auth.register.title": "Créer un compte",
        "auth.register.sub": "Pour une correspondance plus personnelle.",
        "auth.email": "Email",
        "auth.password": "Mot de passe",
        "auth.name": "Nom complet",
        "auth.signIn": "Se connecter",
        "auth.signUp": "Créer",
        "auth.noAccount": "Pas de compte ?",
        "auth.hasAccount": "Déjà un compte ?",
        "acct.title": "Vos commandes",
        "acct.sub": "Toutes vos expéditions.",
        "acct.empty": "Aucune commande.",
        "acct.orderId": "Commande",
        "acct.date": "Le",
        "acct.status": "Statut",
        "acct.amount": "Montant",
        "acct.items": "Articles",
        "admin.title": "Atelier — admin",
        "admin.stats": "Vue d'ensemble",
        "admin.products": "Produits",
        "admin.orders": "Commandes",
        "admin.users": "Clients",
        "admin.revenue": "Revenus",
        "footer.about": "Maison",
        "footer.about.about": "À propos",
        "footer.about.craft": "Artisanat",
        "footer.about.press": "Presse",
        "footer.shop": "Boutique",
        "footer.support": "Service client",
        "footer.support.contact": "Contact",
        "footer.support.shipping": "Expédition",
        "footer.support.returns": "Retours",
        "footer.legal": "© 2026 Keneth Global Inc. Tous droits réservés.",
        "footer.tagline": "Le monde à portée de clic, à tout moment.",
        "common.loading": "Chargement…",
        "badge.new": "Nouveau",
    },
    es: {
        "nav.home": "Inicio",
        "nav.masalas": "Especias Indias",
        "nav.decor": "Decoración",
        "nav.jewelry": "Joyería",
        "nav.shop": "Tienda",
        "nav.account": "Cuenta",
        "nav.login": "Iniciar sesión",
        "nav.logout": "Salir",
        "nav.register": "Registrarse",
        "nav.cart": "Cesta",
        "nav.admin": "Admin",
        "hero.eyebrow": "Fund. India · Exportación a Europa",
        "hero.title": "Los lujos más silenciosos del mundo.",
        "hero.subtitle": "Especias indias de pequeños lotes, textiles artesanales y joyería artesanal — enviados desde Delhi.",
        "hero.cta": "Explorar la colección",
        "hero.cta2": "Nuestra historia",
        "sec.verticals.title": "Tres casas. Un origen.",
        "sec.verticals.sub": "Cada pieza nace en un pequeño taller o cocina familiar.",
        "vert.masalas.title": "La Casa de las Especias",
        "vert.masalas.desc": "Tostadas a mano, molidas a piedra, selladas en horas.",
        "vert.decor.title": "La Casa de los Tejidos",
        "vert.decor.desc": "Textiles estampados y bordados a mano.",
        "vert.jewelry.title": "La Casa de la Joyería",
        "vert.jewelry.desc": "Joyería artesanal hecha a mano — kundan, meenakari, oro del templo.",
        "sec.featured.title": "Destacados esta temporada",
        "sec.featured.sub": "Una selección de las tres casas.",
        "sec.craft.title": "El camino sin prisa",
        "sec.craft.p1": "Nada en nuestros talleres se mide en minutos.",
        "sec.craft.p2": "El resultado: un catálogo de noventa y un productos.",
        "sec.press.title": "Visto en",
        "sec.newsletter.title": "El despacho.",
        "sec.newsletter.sub": "Notas de temporada. Nunca más de dos veces al mes.",
        "sec.newsletter.placeholder": "Su correo",
        "sec.newsletter.submit": "Suscribirse",
        "shop.title": "La tienda",
        "shop.filter.all": "Todo",
        "shop.filter.masalas": "Especias Indias",
        "shop.filter.decor": "Decoración",
        "shop.filter.jewelry": "Joyería",
        "shop.empty": "Ningún producto coincide.",
        "prod.addCart": "Añadir a la cesta",
        "prod.buyNow": "Comprar",
        "prod.details": "Detalles",
        "prod.qty": "Cantidad",
        "prod.related": "También podría gustarle",
        "cart.title": "Su cesta",
        "cart.empty": "Su cesta está vacía.",
        "cart.item": "Artículo",
        "cart.qty": "Cant.",
        "cart.price": "Precio",
        "cart.total": "Total",
        "cart.subtotal": "Subtotal",
        "cart.checkout": "Ir a la caja",
        "cart.continue": "Seguir comprando",
        "cart.remove": "Eliminar",
        "checkout.processing": "Preparando…",
        "success.title": "Gracias.",
        "success.sub": "Su pedido ha sido recibido.",
        "success.orderId": "Referencia",
        "success.viewOrders": "Mis pedidos",
        "cancel.title": "Pago cancelado",
        "cancel.sub": "No se realizó ningún cargo.",
        "cancel.back": "Volver a la cesta",
        "auth.login.title": "Bienvenido de nuevo",
        "auth.login.sub": "Inicie sesión.",
        "auth.register.title": "Crear cuenta",
        "auth.register.sub": "Para una correspondencia más personal.",
        "auth.email": "Correo",
        "auth.password": "Contraseña",
        "auth.name": "Nombre completo",
        "auth.signIn": "Entrar",
        "auth.signUp": "Crear",
        "auth.noAccount": "¿No tiene cuenta?",
        "auth.hasAccount": "¿Ya tiene cuenta?",
        "acct.title": "Sus pedidos",
        "acct.sub": "Registro de cada envío.",
        "acct.empty": "Sin pedidos.",
        "acct.orderId": "Pedido",
        "acct.date": "Realizado el",
        "acct.status": "Estado",
        "acct.amount": "Importe",
        "acct.items": "Artículos",
        "admin.title": "Atelier — admin",
        "admin.stats": "Resumen",
        "admin.products": "Productos",
        "admin.orders": "Pedidos",
        "admin.users": "Clientes",
        "admin.revenue": "Ingresos",
        "footer.about": "Casa",
        "footer.about.about": "Sobre nosotros",
        "footer.about.craft": "Artesanía",
        "footer.about.press": "Prensa",
        "footer.shop": "Tienda",
        "footer.support": "Atención",
        "footer.support.contact": "Contacto",
        "footer.support.shipping": "Envíos",
        "footer.support.returns": "Devoluciones",
        "footer.legal": "© 2026 Keneth Global Inc. Todos los derechos reservados.",
        "footer.tagline": "Compre el mundo, en cualquier momento.",
        "common.loading": "Cargando…",
        "badge.new": "Nuevo",
    },
    it: {
        "nav.home": "Home",
        "nav.masalas": "Spezie Indiane",
        "nav.decor": "Decor",
        "nav.jewelry": "Gioielli",
        "nav.shop": "Shop",
        "nav.account": "Account",
        "nav.login": "Accedi",
        "nav.logout": "Esci",
        "nav.register": "Registrati",
        "nav.cart": "Carrello",
        "nav.admin": "Admin",
        "hero.eyebrow": "Fond. India · Export in Europa",
        "hero.title": "I lussi più discreti del mondo.",
        "hero.subtitle": "Spezie indiane in piccoli lotti, tessili artigianali e gioielli d'artigiano — spediti da Delhi.",
        "hero.cta": "Esplora la collezione",
        "hero.cta2": "La nostra storia",
        "sec.verticals.title": "Tre case. Una provenienza.",
        "sec.verticals.sub": "Ogni pezzo nasce in una piccola bottega o cucina di famiglia.",
        "vert.masalas.title": "La Casa delle Spezie",
        "vert.masalas.desc": "Tostate a mano, macinate a pietra, sigillate in poche ore.",
        "vert.decor.title": "La Casa dei Tessuti",
        "vert.decor.desc": "Tessili stampati a blocchi e ricamati a mano.",
        "vert.jewelry.title": "La Casa dei Gioielli",
        "vert.jewelry.desc": "Gioielli artigianali fatti a mano — kundan, meenakari, oro del tempio.",
        "sec.featured.title": "In evidenza questa stagione",
        "sec.featured.sub": "Una selezione dalle tre case.",
        "sec.craft.title": "La via senza fretta",
        "sec.craft.p1": "Nulla nelle nostre botteghe si misura in minuti.",
        "sec.craft.p2": "Il risultato: un catalogo di novantuno prodotti.",
        "sec.press.title": "Visto su",
        "sec.newsletter.title": "Il dispaccio.",
        "sec.newsletter.sub": "Note stagionali. Mai più di due volte al mese.",
        "sec.newsletter.placeholder": "La tua email",
        "sec.newsletter.submit": "Iscriviti",
        "shop.title": "Lo shop",
        "shop.filter.all": "Tutto",
        "shop.filter.masalas": "Spezie Indiane",
        "shop.filter.decor": "Decor",
        "shop.filter.jewelry": "Gioielli",
        "shop.empty": "Nessun prodotto trovato.",
        "prod.addCart": "Aggiungi al carrello",
        "prod.buyNow": "Compra ora",
        "prod.details": "Dettagli",
        "prod.qty": "Quantità",
        "prod.related": "Potrebbe piacerti",
        "cart.title": "Il tuo carrello",
        "cart.empty": "Il carrello è vuoto.",
        "cart.item": "Articolo",
        "cart.qty": "Qtà",
        "cart.price": "Prezzo",
        "cart.total": "Totale",
        "cart.subtotal": "Subtotale",
        "cart.checkout": "Vai al checkout",
        "cart.continue": "Continua lo shopping",
        "cart.remove": "Rimuovi",
        "checkout.processing": "Preparazione…",
        "success.title": "Grazie.",
        "success.sub": "Il tuo ordine è stato ricevuto.",
        "success.orderId": "Riferimento",
        "success.viewOrders": "I miei ordini",
        "cancel.title": "Pagamento annullato",
        "cancel.sub": "Nessun addebito effettuato.",
        "cancel.back": "Torna al carrello",
        "auth.login.title": "Bentornato",
        "auth.login.sub": "Accedi.",
        "auth.register.title": "Crea un account",
        "auth.register.sub": "Per una corrispondenza più personale.",
        "auth.email": "Email",
        "auth.password": "Password",
        "auth.name": "Nome completo",
        "auth.signIn": "Accedi",
        "auth.signUp": "Crea",
        "auth.noAccount": "Non hai un account?",
        "auth.hasAccount": "Hai già un account?",
        "acct.title": "I tuoi ordini",
        "acct.sub": "Registro di ogni spedizione.",
        "acct.empty": "Nessun ordine.",
        "acct.orderId": "Ordine",
        "acct.date": "Effettuato il",
        "acct.status": "Stato",
        "acct.amount": "Importo",
        "acct.items": "Articoli",
        "admin.title": "Atelier — admin",
        "admin.stats": "In sintesi",
        "admin.products": "Prodotti",
        "admin.orders": "Ordini",
        "admin.users": "Clienti",
        "admin.revenue": "Ricavi",
        "footer.about": "Casa",
        "footer.about.about": "Chi siamo",
        "footer.about.craft": "Artigianalità",
        "footer.about.press": "Stampa",
        "footer.shop": "Shop",
        "footer.support": "Assistenza",
        "footer.support.contact": "Contatto",
        "footer.support.shipping": "Spedizione",
        "footer.support.returns": "Resi",
        "footer.legal": "© 2026 Keneth Global Inc. Tutti i diritti riservati.",
        "footer.tagline": "Il mondo a portata di clic, in ogni momento.",
        "common.loading": "Caricamento…",
        "badge.new": "Nuovo",
    },
};
